exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-console-with-arrow::before {\n  content: \"> \";\n  font-weight: bold;\n  font-size: 1.2em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/console.less
// module id = 198
// module chunks = 0